const cardsToLoadFree = 300

export {
  cardsToLoadFree as default
}